import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/dataflow/message/failed/retry";

export class PostDataFlowRetryFailedMessageCommad extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: PostDataFlowRetryFailedMessageReqData;

    constructor(rayId: string, message: string) {
        super();
        this.params = new PostDataFlowRetryFailedMessageReqData(rayId, message);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class PostDataFlowRetryFailedMessageReqData {
    installationName: string;
    converterType: string;

    constructor(installationName: string, converterType: string) {
        this.installationName = installationName;
        this.converterType = converterType;
    }
}
